















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  IInvoice,
  TFormValidator,
  ICustomer,
  IFindEmailResponse
} from "@/interfaces";
import { USERNAME_RULES } from "@/validators";
import { SubmitInvoice, FindEmail } from "@/api";
import SearchEmail  from "./search-email.vue";
@Component({
  components: {
    SearchEmail
  }
})
export default class SubmitInvoiceComponent extends Vue {
  // @Prop() public invoice!: IInvoice;
  // @Prop() public customer!: ICustomer;
	
	@Prop()
	public InvoiceNumber!: string ;
	
	@Prop()
	public InvoiceTotal!: number;
	
	@Prop()
	public CustomerName!: string;
	
	@Prop()
	public CustomerEmail: string;
	
	@Prop({default: false})
	public IsOptional: boolean;
	
	@Prop({default: 0})
	public MessageID: number;
	
	@Watch("CustomerEmail", {immediate:true}) 
	onCustomerEmail(newVal:string, oldVal:string)
	{
		if (newVal && newVal.length>0)
			this.emailList.push(newVal);
	}
	
	// public invoiceToEdit!: IInvoice;
  public emailRules: TFormValidator[] = [
    v => {
      if (v) {
        return /.+@.+\..+/.test(v) || "The field email must be valid";
      } else {
        return true;
      }
    }
  ];
  public valid = false;
  public loading = false;
	public emailList: string[]=[];
	public message: string = '';

  mounted() {
    // this.invoiceToEdit = { ...this.invoice };
	}
	
  close() {
    this.$emit("close");
	}
	
  async submit() {
		this.$emit("submit", this.emailList, this.message);
  }

  async skip() {
		this.$emit("skip");
  }

	
}
